export const exportToHTML = (blocks, subject, bodySettings = {}) => {
  const blocksHTML = blocks.map(block => blockToHTML(block)).join('\n')
  const bs = bodySettings || {}
  const emailWidth = bs.emailWidth || 600
  const bgColor = bs.backgroundColor || '#f4f4f4'
  const contentBg = bs.contentBackgroundColor || '#ffffff'
  const fontFamily = bs.fontFamily || 'Arial, sans-serif'
  const contentPadding = bs.contentPadding ? `padding: ${bs.contentPadding}%;` : ''
  const contentRadius = bs.contentBorderRadius && bs.contentBorderRadius !== '0px' ? `border-radius: ${bs.contentBorderRadius};` : ''
  const linkColor = bs.linkColor || '#007bff'
  const preheaderText = bs.preheaderText || ''

  const preheaderHTML = preheaderText ? `
  <div style="display: none; font-size: 1px; color: ${bgColor}; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;">
    ${preheaderText}
    ${'&zwnj;&nbsp;'.repeat(30)}
  </div>` : ''

  return `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>${subject || 'Email'}</title>
  <!--[if mso]>
  <noscript>
    <xml>
      <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  </noscript>
  <![endif]-->
  <style type="text/css">
    /* Reset */
    body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    img { -ms-interpolation-mode: bicubic; border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    body { margin: 0; padding: 0; width: 100% !important; }
    a { color: ${linkColor}; }

    /* Responsive */
    @media only screen and (max-width: 620px) {
      .email-container {
        width: 100% !important;
        max-width: 100% !important;
      }
      .email-content {
        padding: 8px !important;
      }
      .responsive-table {
        width: 100% !important;
      }
      .stack-column {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        direction: ltr !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .stack-column-table {
        width: 100% !important;
      }
      .responsive-img {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
      }
      .mobile-center {
        text-align: center !important;
      }
      .mobile-padding {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
      .mobile-font-lg {
        font-size: 24px !important;
        line-height: 1.3 !important;
      }
      .mobile-font-md {
        font-size: 16px !important;
        line-height: 1.5 !important;
      }
      .mobile-button {
        display: block !important;
        width: 100% !important;
        text-align: center !important;
      }
      .mobile-hide {
        display: none !important;
      }
      .mobile-full-width {
        width: 100% !important;
        max-width: 100% !important;
      }
    }

    @media only screen and (max-width: 480px) {
      .mobile-font-lg {
        font-size: 20px !important;
      }
      .mobile-font-md {
        font-size: 14px !important;
      }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: ${fontFamily}; background-color: ${bgColor};">
  ${preheaderHTML}
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: ${bgColor};" role="presentation">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <!--[if mso]><table width="${emailWidth}" cellpadding="0" cellspacing="0" border="0" align="center"><tr><td><![endif]-->
        <table class="email-container" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: ${contentBg}; max-width: ${emailWidth}px; ${contentRadius} overflow: hidden;" role="presentation">
          <tr>
            <td class="email-content" style="${contentPadding}">
              ${blocksHTML}
            </td>
          </tr>
        </table>
        <!--[if mso]></td></tr></table><![endif]-->
      </td>
    </tr>
  </table>
</body>
</html>`
}

const blockToHTML = (block) => {
  const { type, settings } = block

  switch (type) {
    case 'text':
      return textBlockToHTML(settings)
    case 'heading':
      return headingBlockToHTML(settings)
    case 'image':
      return imageBlockToHTML(settings)
    case 'button':
      return buttonBlockToHTML(settings)
    case 'columns':
      return columnsBlockToHTML(settings)
    case 'menu':
      return menuBlockToHTML(settings)
    case 'divider':
      return dividerBlockToHTML(settings)
    case 'spacer':
      return spacerBlockToHTML(settings)
    case 'html':
      return htmlBlockToHTML(settings)
    case 'social':
      return socialBlockToHTML(settings)
    case 'video':
      return videoBlockToHTML(settings)
    case 'table':
      return tableBlockToHTML(settings)
    default:
      return ''
  }
}

const getSpacingStyle = (padding, margin) => {
  const p = padding || {}
  const m = margin || {}
  return `padding: ${p.top || '0px'} ${p.right || '0px'} ${p.bottom || '0px'} ${p.left || '0px'}; margin: ${m.top || '0px'} ${m.right || '0px'} ${m.bottom || '0px'} ${m.left || '0px'};`
}

const getBackgroundImageStyle = (settings) => {
  if (!settings.backgroundImage) return ''
  let style = `background-image: url('${settings.backgroundImage}');`
  style += ` background-size: ${settings.backgroundSize || 'cover'};`
  style += ` background-position: ${settings.backgroundPosition || 'center center'};`
  style += ` background-repeat: ${settings.backgroundRepeat || 'no-repeat'};`
  return style
}

const getBorderStyle = (settings) => {
  if (!settings.borderWidth || settings.borderWidth === '0px') return ''
  return `border: ${settings.borderWidth} ${settings.borderColor || '#ccc'} solid; border-radius: ${settings.borderRadius || '0px'};`
}

const textBlockToHTML = (settings) => {
  const bgImg = getBackgroundImageStyle(settings)
  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${settings.textAlign || 'left'}" class="mobile-padding mobile-font-md" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'}; ${bgImg} ${getBorderStyle(settings)}">
      <div style="font-size: ${settings.fontSize}; font-family: ${settings.fontFamily}; font-weight: ${settings.fontWeight}; color: ${settings.color}; text-align: ${settings.textAlign}; line-height: ${settings.lineHeight};">
        ${settings.content}
      </div>
    </td>
  </tr>
</table>`
}

const headingBlockToHTML = (settings) => {
  const bgImg = getBackgroundImageStyle(settings)
  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${settings.textAlign || 'center'}" class="mobile-padding mobile-font-lg" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'}; ${bgImg} ${getBorderStyle(settings)}">
      <h1 style="margin: 0; font-size: ${settings.fontSize}; font-family: ${settings.fontFamily}; font-weight: ${settings.fontWeight}; color: ${settings.color}; text-align: ${settings.textAlign}; line-height: ${settings.lineHeight};">
        ${settings.content}
      </h1>
    </td>
  </tr>
</table>`
}

const imageBlockToHTML = (settings) => {
  if (!settings.src) return ''

  const align = settings.textAlign || 'center'
  const width = settings.width || '100%'
  const isPercentage = width.includes('%')
  const widthAttr = isPercentage ? '' : `width="${parseInt(width)}"`
  const widthStyle = isPercentage ? `width: ${width};` : `width: ${width};`

  const imgTag = `<img src="${settings.src}" alt="${settings.alt}" ${widthAttr} class="responsive-img" style="display: block; ${widthStyle} height: ${settings.height}; max-width: 100%; ${getBorderStyle(settings)}" />`
  const content = settings.link ? `<a href="${settings.link}" target="_blank">${imgTag}</a>` : imgTag

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${align}" class="mobile-center" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'};">
      ${content}
    </td>
  </tr>
</table>`
}

const buttonBlockToHTML = (settings) => {
  const align = settings.textAlign || 'center'
  const width = settings.width === 'auto' ? 'auto' : settings.width
  const p = settings.padding || {}
  const btnPadTop = p.top || '12px'
  const btnPadRight = p.right || '24px'
  const btnPadBottom = p.bottom || '12px'
  const btnPadLeft = p.left || '24px'
  const btnPadding = `${btnPadTop} ${btnPadRight} ${btnPadBottom} ${btnPadLeft}`
  const m = settings.margin || {}
  const outerMargin = `${m.top || '0'} ${m.right || '0'} ${m.bottom || '0'} ${m.left || '0'}`
  const borderRadius = settings.borderRadius || '6px'
  const arcSize = Math.round((parseInt(borderRadius) / 40) * 100) || 0

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${align}" class="mobile-center" style="margin: ${outerMargin}; padding: 10px 0;">
      <!--[if mso]>
      <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${settings.link}" style="height:auto;v-text-anchor:middle;${width !== 'auto' ? `width:${width};` : ''}" arcsize="${arcSize}%" fillcolor="${settings.backgroundColor}">
      <w:anchorlock/>
      <center style="color:${settings.color};font-family:${settings.fontFamily};font-size:${settings.fontSize};font-weight:${settings.fontWeight};padding:${btnPadding};">${settings.text}</center>
      </v:roundrect>
      <![endif]-->
      <!--[if !mso]><!-->
      <a href="${settings.link}" target="_blank" style="display: inline-block; background-color: ${settings.backgroundColor}; color: ${settings.color}; font-size: ${settings.fontSize}; font-family: ${settings.fontFamily}; font-weight: ${settings.fontWeight}; text-decoration: none; padding: ${btnPadding}; border-radius: ${borderRadius}; ${settings.borderWidth && settings.borderWidth !== '0px' ? `border: ${settings.borderWidth} solid ${settings.borderColor || '#0056b3'};` : ''} mso-hide: all; text-align: center; ${width !== 'auto' ? `width: ${width}; box-sizing: border-box;` : ''}">
        ${settings.text}
      </a>
      <!--<![endif]-->
    </td>
  </tr>
</table>`
}

const columnsBlockToHTML = (settings) => {
  const columnWidth = Math.floor(100 / settings.columnCount)
  const columnsHTML = (settings.columns || []).map(col => {
    const colBlocks = (col.blocks || []).map(block => blockToHTML(block)).join('\n')
    const content = col.content ? `<p style="margin: 0; padding: 10px;">${col.content}</p>` : ''
    return `
    <!--[if mso]><td width="${columnWidth}%" valign="top"><![endif]-->
    <div class="stack-column" style="display: inline-block; vertical-align: top; width: ${columnWidth}%;">
      <table class="stack-column-table" width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td style="padding: ${parseInt(settings.gap) / 2 || 5}px; vertical-align: top;">
            ${content}${colBlocks}
          </td>
        </tr>
      </table>
    </div>
    <!--[if mso]></td><![endif]-->`
  }).join('\n')

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
  <tr>
    <td style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'};">
      <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><![endif]-->
      <div style="font-size: 0; text-align: center;">
        ${columnsHTML}
      </div>
      <!--[if mso]></tr></table><![endif]-->
    </td>
  </tr>
</table>`
}

const menuBlockToHTML = (settings) => {
  const align = settings.textAlign || 'center'
  const links = (settings.links || []).map((link, idx) => {
    const separator = idx < settings.links.length - 1 ? `<span style="color: ${settings.color};">${settings.separator}</span>` : ''
    return `<a href="${link.url}" style="color: ${settings.color}; text-decoration: none; font-size: ${settings.fontSize}; font-family: ${settings.fontFamily};">${link.text}</a>${separator}`
  }).join(' ')

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${align}" class="mobile-center mobile-padding" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'}; font-size: ${settings.fontSize}; font-family: ${settings.fontFamily};">
      ${links}
    </td>
  </tr>
</table>`
}

const dividerBlockToHTML = (settings) => {
  const width = settings.width || '100%'
  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
  <tr>
    <td align="center" style="${getSpacingStyle(settings.padding, settings.margin)}">
      <!--[if mso]><table width="${width}" cellpadding="0" cellspacing="0" border="0" align="center"><tr><td><![endif]-->
      <div style="width: ${width}; height: ${settings.height}; background-color: ${settings.color}; border: none; margin: 0 auto;"></div>
      <!--[if mso]></td></tr></table><![endif]-->
    </td>
  </tr>
</table>`
}

const spacerBlockToHTML = (settings) => {
  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
  <tr>
    <td style="height: ${settings.height}; background-color: ${settings.backgroundColor || 'transparent'}; font-size: 0; line-height: 0;">&nbsp;</td>
  </tr>
</table>`
}

const htmlBlockToHTML = (settings) => {
  const bgImg = getBackgroundImageStyle(settings)
  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
  <tr>
    <td style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'}; ${bgImg} ${getBorderStyle(settings)}">
      ${settings.htmlContent || ''}
    </td>
  </tr>
</table>`
}

const socialBlockToHTML = (settings) => {
  const align = settings.textAlign || 'center'
  const iconSize = settings.iconSize || '32'
  const iconStyle = settings.iconStyle || 'colored'

  const socialColors = {
    facebook: '#1877F2',
    twitter: '#1DA1F2',
    instagram: '#E4405F',
    linkedin: '#0A66C2',
    youtube: '#FF0000',
    tiktok: '#000000',
    pinterest: '#E60023',
    github: '#333333'
  }

  const socialLabels = {
    facebook: 'Facebook',
    twitter: 'X (Twitter)',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    youtube: 'YouTube',
    tiktok: 'TikTok',
    pinterest: 'Pinterest',
    github: 'GitHub'
  }

  const icons = (settings.networks || []).filter(n => n.enabled && n.url).map(network => {
    const bgColor = iconStyle === 'colored' ? socialColors[network.name] || '#333333' : (iconStyle === 'dark' ? '#333333' : '#cccccc')
    const label = socialLabels[network.name] || network.name

    return `<td align="center" valign="middle" style="padding: 0 ${parseInt(settings.iconSpacing) / 2 || 4}px;">
      <a href="${network.url}" target="_blank" style="text-decoration: none; display: inline-block;">
        <table cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tr>
            <td align="center" valign="middle" style="width: ${iconSize}px; height: ${iconSize}px; background-color: ${bgColor}; border-radius: ${settings.iconRadius || '50%'};">
              <span style="color: #ffffff; font-size: ${Math.round(parseInt(iconSize) * 0.45)}px; font-weight: bold; font-family: Arial, sans-serif; line-height: ${iconSize}px;">${label.charAt(0).toUpperCase()}</span>
            </td>
          </tr>
        </table>
      </a>
    </td>`
  }).join('\n')

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${align}" class="mobile-center" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'};">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation" style="display: inline-block;">
        <tr>
          ${icons}
        </tr>
      </table>
    </td>
  </tr>
</table>`
}

const videoBlockToHTML = (settings) => {
  const align = settings.textAlign || 'center'
  const width = settings.width || '100%'
  const thumbnailUrl = settings.thumbnailUrl || `https://img.youtube.com/vi/${extractVideoId(settings.videoUrl)}/maxresdefault.jpg`
  const videoUrl = settings.videoUrl || '#'

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="responsive-table">
  <tr>
    <td align="${align}" class="mobile-center" style="${getSpacingStyle(settings.padding, settings.margin)} background-color: ${settings.backgroundColor || 'transparent'};">
      <a href="${videoUrl}" target="_blank" style="text-decoration: none; display: inline-block; width: ${width}; max-width: 100%;">
        <table cellpadding="0" cellspacing="0" border="0" role="presentation" width="100%">
          <tr>
            <td align="center">
              <img src="${thumbnailUrl}" alt="${settings.altText || 'Video thumbnail'}" class="responsive-img" style="display: block; width: ${width}; max-width: 100%; height: auto; ${getBorderStyle(settings)}" />
            </td>
          </tr>
          <tr>
            <td align="center" style="padding-top: 8px;">
              <table cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tr>
                  <td align="center" style="background-color: #ff0000; border-radius: 4px; padding: 8px 20px;">
                    <a href="${videoUrl}" target="_blank" style="color: #ffffff; text-decoration: none; font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;">&#9654; Play Video</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </a>
    </td>
  </tr>
</table>`
}

const tableBlockToHTML = (settings) => {
  const rows = settings.rows || []
  const headerBg = settings.headerBackgroundColor || '#f8f9fa'
  const headerColor = settings.headerTextColor || '#333333'
  const borderColor = settings.tableBorderColor || '#dee2e6'
  const cellPadding = settings.cellPadding || '10px'

  let headerHTML = ''
  if (settings.showHeader && rows.length > 0) {
    const headerCells = rows[0].map(cell =>
      `<th style="padding: ${cellPadding}; background-color: ${headerBg}; color: ${headerColor}; font-weight: bold; text-align: left; border: 1px solid ${borderColor}; font-family: ${settings.fontFamily || 'Arial, sans-serif'}; font-size: ${settings.fontSize || '14px'};">${cell}</th>`
    ).join('\n')
    headerHTML = `<tr>${headerCells}</tr>`
  }

  const startIdx = settings.showHeader ? 1 : 0
  const bodyRows = rows.slice(startIdx).map((row, rowIdx) => {
    const rowBg = settings.striped && rowIdx % 2 === 1 ? '#f8f9fa' : 'transparent'
    const cells = row.map(cell =>
      `<td style="padding: ${cellPadding}; border: 1px solid ${borderColor}; font-family: ${settings.fontFamily || 'Arial, sans-serif'}; font-size: ${settings.fontSize || '14px'}; color: ${settings.color || '#333333'}; background-color: ${rowBg};">${cell}</td>`
    ).join('\n')
    return `<tr>${cells}</tr>`
  }).join('\n')

  return `
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
  <tr>
    <td style="${getSpacingStyle(settings.padding, settings.margin)}">
      <table class="responsive-table" width="${settings.tableWidth || '100%'}" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; border: 1px solid ${borderColor};" role="presentation">
        ${headerHTML}
        ${bodyRows}
      </table>
    </td>
  </tr>
</table>`
}

function extractVideoId(url) {
  if (!url) return ''
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/)
  return match ? match[1] : ''
}
